import { axiosInstance } from '@/services/api/axios';
import type { ResumeReaderResponse } from '@/services/api/types';

const VALID_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const resumeApi = {
  parseResume: async (file: File, _accessToken?: string): Promise<ResumeReaderResponse> => {
    if (!VALID_TYPES.includes(file.type)) {
      throw new Error('Invalid file type. Please upload PDF, DOC, or DOCX.');
    }

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      throw new Error('File size exceeds 10MB limit.');
    }

    const formData = new FormData();
    formData.append('resume', file);

    const response = await axiosInstance.post<ResumeReaderResponse>('resume-reader', formData, {
      headers: { 'Content-Type': undefined as unknown as string },
    });

    return response.data;
  },
};
